import React, { useState } from "react";

const CreatedActivity = ({ modalData, formatKey, formatActivityVal }) => {

    return (
        <table className="history-table">
            <thead>
                <tr>
                    <th>Fields</th>
                    <th>Value</th>
                </tr>
            </thead>

            <tbody>
                {Object.keys({
                    ...(modalData.new_data || {}),
                }).map((key) => (
                    <tr key={key}>
                        <td>{key === "product_key" ? "Product" : formatKey(key)}</td>
                        <td className="neww">
                            {formatActivityVal(key, modalData.new_data[key]) || "—"}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default CreatedActivity;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/activity/CreatedActivity.js